import React, { useEffect, useRef, useState } from "react";
import Search from "../../../components/Search";
import { useDispatch, useSelector } from "react-redux";
import { Divider, Dropdown, Form, Progress, Select, Table } from "antd";
import CardLoading from "../../../components/CardLoading";
import { Link, useNavigate } from "react-router-dom";
import svg15 from "../../../assets/svg/svg15.svg";
import { fetchData } from "../../../features/fetch/fetchSlice";
import moment from "moment";
import { setActiveObj } from "../../../features/obj/objSlice";
import svg36 from "../../../assets/svg/svg36.svg";
import BgHeader from "../BgHeader";
import { cashConverter, formatText } from "../../../utils";

function LandingProjects() {
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const [form] = Form.useForm();
  const formRef = useRef(null);
  const url = "api/v2/main_projects/getAll";

  const { loading, data, count } = useSelector((state) => ({
    loading: state.fetch.loading,
    data: state.fetch.data[url] || [],
    count: state.fetch.count[url] || 0,
    // activeObjPathCard: state.obj.activeObj["pathwayCard"],
  }));

  const { refetchKey } = useSelector((state) => state.global);

  const [searchInput, setsearchInput] = useState(null);
  const [prodd, setProdd] = useState("");
  const [selectId, setSelectId] = useState("ONGOING");
  const [activeBtn, setActiveBtn] = useState(null);

  const handleSearch = (e) => {
    setsearchInput(e.target.value);
    dispatch(
      fetchData({
        url: url,
        projectName: e.target.value == "" ? null : e.target.value,
        projectStatus: activeBtn,
      }),
    );
  };

  const handleView = async (item) => {
    await dispatch(
      setActiveObj({
        key: selectId === "PLANNED" ? "plannedProject" : "ongoingProject",
        data: item,
      }),
    );
    await navigate(
      selectId === "PLANNED" ? "planned-pipeline-details" : "/project-view",
    );
  };
  const handleViewName = async (item) => {
    await dispatch(
      setActiveObj({
        key: selectId === "PLANNED" ? "plannedProject" : "ongoingProject",
        data: item,
      }),
    );
    await navigate(
      selectId === "PLANNED" ? "planned-pipeline-details" : "/project-view",
    );
  };

  const settingItems = [
    {
      key: "1",
      label: (
        <div
        //  onClick={handleOpenDelete}
        >
          <Link className="flex items-center gap-x-2 actions-text my-2">
            <span className="whitespace-nowrap">PDF</span>
          </Link>
          <div className="mt-[1rem]">
            <Divider />
          </div>
        </div>
      ),
    },

    {
      key: "2",
      label: (
        <div
        //  onClick={handleOpenDelete}
        >
          <Link className="flex items-center gap-x-2 actions-text my-2">
            <span className="whitespace-nowrap">Excel</span>
          </Link>
        </div>
      ),
    },
  ];

  const columns = [
    {
      title: "#",
      dataIndex: "index",
      key: "index",
      render: (_, __, index) => index + 1,
    },
    {
      title: "Project Name",
      render: (item) => {
        return <div className="cursor-pointer">{item?.projectName}</div>;
      },
      sorter: (a, b) => a.projectName.localeCompare(b.projectName),
    },

    {
      title: "Type",
      dataIndex: "projectTypeName",
      sorter: (a, b) => a.projectTypeName.localeCompare(b.projectTypeName),
    },
    {
      title: "Contractor",
      dataIndex: "projectContractor",
      sorter: (a, b) => a.projectContractor.localeCompare(b.projectContractor),
    },
    {
      title: "Implementing Agency",
      dataIndex: "projectAgencyName",
      sorter: (a, b) => a.projectAgencyName.localeCompare(b.projectAgencyName),
    },

    {
      title: "County",
      dataIndex: "projectCountyName",
      sorter: (a, b) => a.projectCountyName.localeCompare(b.projectCountyName),
    },

    {
      title: "Project Cost",
      dataIndex: "projectCost",
      render: (item) => {
        return <div>{cashConverter(item)}</div>;
      },
      sorter: (a, b) => a.projectCost.localeCompare(b.projectCost),
    },

    {
      title: "Start Date",
      dataIndex: "projectStartDate",
      width: 150,
      render: (text) => (text ? moment(text).format("DD-MM-YYYY") : "--"),
      sorter: (a, b) =>
        moment(a.projectStartDate).valueOf() -
        moment(b.projectStartDate).valueOf(),
    },
    {
      title: "Progress",
      dataIndex: "projectCompletionRate",
      render: (item) => {
        return <div>{<Progress percent={item} />}</div>;
      },
      sorter: (a, b) =>
        a.projectCompletionRate.localeCompare(b.projectCompletionRate),
    },
    {
      title: "Status",
      dataIndex: "projectStatus",
      render: (item) => {
        const colors = {
          ACTIVE: "#28A745",
          COMPLETED: "#3250FF",
          ONGOING: "#FFA500",
          PIPELINED: "#6C757D",
        };

        return (
          <div
            className="text-[#FFF] inline-block rounded-[8px] px-[8px] py-[4px] w-auto !text-[12px]"
            style={{
              backgroundColor: colors[item] || "darkGreen",
            }}
          >
            {formatText(item)}
          </div>
        );
      },
    },

    // {
    //   title: "Actions",
    //   render: (item) => (
    //     <>
    //       <button onClick={() => handleView(item)}>
    //         <img src={svg15} alt="svg15" />
    //       </button>
    //     </>
    //   ),
    // },
  ];

  const handleClick = async (item) => {
    await setActiveBtn(item);
  };

  const [pageIndex, setPageIndex] = useState(0);
  const [pageSize, setPageSize] = useState(10);

  async function fetchTableData(page, size) {
    await dispatch(
      fetchData({
        url: url,
        projectStatus: activeBtn,
        projectName: searchInput,
        limit: size ?? pageSize,
        start: page ?? pageIndex,
      }),
    );
  }

  useEffect(() => {
    fetchTableData();
  }, [activeBtn]);

  if (loading && !searchInput)
    return (
      <div className="mt-[15rem] w-full text-center flex items-center justify-center">
        <CardLoading />
      </div>
    );
  return (
    <>
      <div className="w-full bg-[#F7F7F7] overflow-x-hidden" id="projects">
        <BgHeader title="Projects" />
        <div className="flex lg:flex-row flex-col lg:gap-x-[2rem] gap-y-[1.25rem] px-[1rem] sm:px-[1.25rem] lg:pt-[3.75rem] pt-[1.75rem] max-w-full">
          <div className="flex flex-col flex-shrink-0">
            <span className="text-[#050505] text-[1.125rem] font-sora font-[400] ">
              ALL PROJECTS
            </span>

            <div className="flex lg:flex-col flex-row items-start gap-[.43rem] w-auto lg:p-1.5 overflow-x-auto flex-wrap lg:flex-nowrap">
              {[
                { value: null, label: "All" },
                { value: "ONGOING", label: "Ongoing" },
                { value: "COMPLETED", label: "Complete" },
                { value: "PIPELINED", label: "Pipeline" },
              ]?.map((btn) => (
                <button
                  key={btn?.label}
                  onClick={() => handleClick(btn?.value)}
                  className={`${
                    activeBtn === btn?.value ? "text-[#fff] bg-[#637381] " : ""
                  }flex items-start font-[400] font-sora text-[.875rem] rounded-[.3125rem] py-[.5rem] px-[1rem] whitespace-nowrap`}
                >
                  {btn?.label}
                </button>
              ))}
            </div>
          </div>
          <div className="w-full flex flex-col min-w-0">
            <div className="flex sm:flex-row flex-col items-start sm:items-center justify-between w-full gap-[1rem]">
              <div className="w-full sm:w-auto sm:flex-1 sm:max-w-[29.1875rem]">
                <Search
                  searchInput={searchInput}
                  handleSearch={handleSearch}
                  text={"Search ..."}
                />
              </div>
             
            </div>
            <div className="overflow-x-auto w-full">
              <Table
                rowSelection={false}
                className="mt-[1.31rem]"
                scroll={{
                  x: 1200,
                }}
                rowKey={(record) => record?.projectId}
                columns={columns}
                dataSource={data}
                loading={loading}
                pagination={{
                  position: ["bottomRight"],
                  current: pageIndex + 1,
                  total: count,
                  pageSize: pageSize,
                  onChange: (page, size) => {
                    setPageIndex(page - 1);
                    setPageSize(size);
                    fetchTableData(page - 1, size);
                  },
                  showSizeChanger: false,
                  hideOnSinglePage: true,
                }}
              />{" "}
            </div>
          </div>
        </div>
      </div>
    </>
  );
}

export default LandingProjects;
